module.exports = __webpack_public_path__ + "img/170.4cf5de96.png";